import React from "react";
import { Form } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import FormNumberInput from "go-form/components/FormNumberInput";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { TimePicker } from "go-form/components/TimePicker";
import { LinkAppModalFormProps, getValidityTypeOptions } from "../../../utils/utils";

interface Props {
	form: UseFormReturn<LinkAppModalFormProps>;
}

const GoZoneProduct = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
		register,
		setValue,
		watch,
	} = form;
	const selectedValidityType = watch(`validity_type`);
	const displayValidToTimeInput = selectedValidityType === "TODAY" || selectedValidityType === "NUMBER_OF_DAYS";
	const displayNumberOfDaysInput = selectedValidityType === "NUMBER_OF_DAYS";
	const displayValidFromAndValidToInputs = selectedValidityType === "PERIOD";
	const displayAnyAdditionalInput =
		displayValidToTimeInput || displayNumberOfDaysInput || displayValidFromAndValidToInputs;

	return (
		<>
			<FormCheck
				type="switch"
				register={register}
				errors={errors}
				name="provide_code_manually"
				label={t("modules.app_link.field.provide_code_manually.title")}
			/>
			<FormSelectGroup
				control={control}
				errors={errors}
				name="validity_type"
				options={getValidityTypeOptions(t)}
				label={t("modules.app_link.field.validity_type.title")}
				getOptionValue={(option) => option.id}
				defaultValue={getValidityTypeOptions(t)[0]}
			/>
			{displayAnyAdditionalInput && (
				<div className="row">
					{displayValidToTimeInput && (
						<div className="col-md-4">
							<Form.Label style={{ fontSize: "13px", marginBottom: "1.6px" }}>
								{t("modules.app_link.field.valid_to_time.title")}
							</Form.Label>
							<TimePicker
								time="00:00:00"
								onChange={(time: string) => {
									setValue("valid_to_time", `${time}:00`);
								}}
							/>
						</div>
					)}
					{displayNumberOfDaysInput && (
						<div className="col-md-4">
							<FormNumberInput
								name="number_of_days"
								control={control}
								errors={errors}
								label={t("modules.app_link.field.number_of_days.title")}
								suffix=""
							/>
						</div>
					)}
					{displayValidFromAndValidToInputs && (
						<>
							<div className="col-md-4">
								<FormDatePicker
									control={control}
									errors={errors}
									name="valid_from"
									label={t("modules.app_link.field.valid_from.title")}
									dayPicker
									timePicker={false}
								/>
							</div>
							<div className="col-md-4">
								<FormDatePicker
									control={control}
									errors={errors}
									name="valid_to"
									label={t("modules.app_link.field.valid_to.title")}
									dayPicker
									timePicker={false}
								/>
							</div>
						</>
					)}
				</div>
			)}
		</>
	);
};

export default GoZoneProduct;
